import React, { useEffect, useContext, useState, useCallback } from "react";
import { getProgramsAurum, getProgramsCoach, getCLientById, getWorkoutsAurum, getWorkoutsCoach, getMealplansAurum, getMealplansCoach }  from "../../../services/firebase/firestore/getData";
import "./Programs.scss";
import UserContext from "../../../services/context/userContext";
import { updatePrograms, updateWorkouts, updateMealplans } from "../../../services/firebase/firestore/updateData";
import Input from "../../../components/_default/Input";
import Loading from "../../../components/_default/Loading";

export default function Programs({ client_id, time }) {
  localStorage.removeItem("tabIndex")
  const user = useContext(UserContext);
  const [programsList, setProgramsList] = useState([]);
  const [activePrograms, setActivePrograms] = useState([]);

  const [workoutsList, setWorkoutsList] = useState([]);
  const [activeWorkouts, setActiveWorkouts] = useState([]);

  const [mealplansList, setMealplansList] = useState([]);
  const [activeMealplans, setActiveMealplans] = useState([]);
  const [loading, setLoading] = useState(false);

  const [visibleTab, setVisibleTab] = useState('Programs');

  const tab_options = ['Programs', 'Workouts', 'Mealplans'];

  function getPrograms(client_id) {
    getProgramsAurum((aurum_result) => {
      getProgramsCoach(user.id, (coach_result) => {
        let all_programs = (aurum_result) ? aurum_result.concat(coach_result) : coach_result;
        setProgramsList(all_programs);

        getCLientById(client_id, (result) => {
            let active_programs = (result.programs) ? result.programs : [];
            setActivePrograms(active_programs);
            setLoading(false);
        })
      });
    });
  }

  function getWorkouts(client_id) {
    getWorkoutsAurum((aurum_result) => {
      getWorkoutsCoach(user.id, (coach_result) => {
        let all_workouts = (aurum_result) ? aurum_result.concat(coach_result) : coach_result;
        setWorkoutsList(all_workouts);
        getCLientById(client_id, (result) => {
            let active_workouts = (result.workouts) ? result.workouts : [];
            setActiveWorkouts(active_workouts);
            setLoading(false);
        })
      });
    });
  }

  function getMealplans(client_id) {
    getMealplansAurum((aurum_result) => {
      getMealplansCoach(user.id, (coach_result) => {
        let all_mealplans = (aurum_result) ? aurum_result.concat(coach_result) : coach_result;
        setMealplansList(all_mealplans);
        getCLientById(client_id, (result) => {
            let active_mealpans = (result.mealplans) ? result.mealplans : [];
            setActiveMealplans(active_mealpans);
            setLoading(false);
        })
      });
    });
  }

  function clone(obj) {
      if(obj == null || typeof(obj) != 'object')
          return obj;    
      var temp = new obj.constructor(); 
      for(var key in obj)
          temp[key] = clone(obj[key]);    
      return temp;
  }

  function remove_duplicates(arr) {
      var obj = {};
      var ret_arr = [];
      for (var i = 0; i < arr.length; i++) {
          obj[arr[i]] = true;
      }
      for (var key in obj) {
          ret_arr.push(key);
      }
      return ret_arr;
  }

  const doCheckPrograms = (checked) => {
    setLoading(true);
    let active_programs = activePrograms;
    active_programs.push(checked)
    active_programs = remove_duplicates(active_programs);
    updatePrograms(client_id, active_programs, (callback) => {
      getPrograms(client_id);
    });
  }

  const unCheckPrograms = (checked) => {
    setLoading(true);
    let active_programs = activePrograms;
    let active = active_programs.filter(program => program !== checked);
    active_programs = active;
    active_programs = remove_duplicates(active_programs);
    updatePrograms(client_id, active_programs, (callback) => {
      getPrograms(client_id);
    });
  }

  const doCheckWorkouts = (checked) => {
    setLoading(true);
    let active_workouts = activeWorkouts;
    active_workouts.push(checked)
    active_workouts = remove_duplicates(active_workouts);
    updateWorkouts(client_id, active_workouts, (callback) => {
      getWorkouts(client_id);
    });
  }

  const unCheckWorkouts = (checked) => {
    setLoading(true);
    let active_workouts = activeWorkouts;
    let active = active_workouts.filter(workout => workout !== checked);
    active_workouts = active;
    active_workouts = remove_duplicates(active_workouts);
    updateWorkouts(client_id, active_workouts, (callback) => {
      getWorkouts(client_id);
    });
  }

  const doCheckMealplans = (checked) => {
    setLoading(true);
    let active_mealplans = activeWorkouts;
    active_mealplans.push(checked)
    active_mealplans = remove_duplicates(active_mealplans);
    updateMealplans(client_id, active_mealplans, (callback) => {
      getMealplans(client_id);
    });
  }

  const unCheckMealplans = (checked) => {
    setLoading(true);
    let active_mealplans = activeMealplans;
    let active = active_mealplans.filter(mealplan => mealplan !== checked);
    active_mealplans = active;
    active_mealplans = remove_duplicates(active_mealplans);
    updateMealplans(client_id, active_mealplans, (callback) => {
      getMealplans(client_id);
    });
  }

  useEffect(() => {
    getPrograms(client_id);
    getWorkouts(client_id);
    getMealplans(client_id);
  }, [time, client_id])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div style={{ marginBottom: 10, marginTop: 40, width: 300, alignSelf: 'flex-end', marginRight: 50 }}>
        <Input type="select" label=" " value={visibleTab} options={tab_options} onChange={(e) => setVisibleTab(e)} />
      </div>

      
        <>
          {
            (visibleTab == 'Programs') && (
              <div className="c-workout-wrapper" style={{ backgroundColor: '#e7e9ed', marginBottom: 0, marginTop: -110 }}>
                <div className="c-workout-content">
                  <h2>Programs</h2>
                  {/* <span>Set the programs visible for the client</span><br /><br /> */}
                  <span>Enable/Disable access to programs </span><br /><br />
                  {
                    loading ? <Loading /> : (
                      <div className="c-exercise-list">
                        {programsList.length>0&&programsList?.map((item, idx) => (
                          // console.log(activePrograms.filter(program => program === item.id)) &&
                            <div className="c-exercise-list-item">
                              <div className="c-exercise-list-item-data">
                                <div style={{ width: 65, position: "relative", height: 45, float: 'left'  }}>
                                  <label className="switch">
                                    {activePrograms.filter(program => program === item.id).length > 0 ? (
                                      <input type="checkbox" onChange={ () => { unCheckPrograms(item.id) } } name="Back"  checked />
                                    ):(
                                      <input type="checkbox" onChange={ () => { doCheckPrograms(item.id) } } name="Back"  />
                                    )}
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                                <div className="c-exercise-text">
                                  <h3>{item.name}</h3>
                                  <span style={{ fontWeight: 300 }}>{item.phases} Phases - {item.weeks} Weeks</span>
                                </div>
                              </div>
                            </div>
                            
                          ))}
                        </div>
                    )
                  }
                  
                </div> 
              </div>
            )
          }
          {
            (visibleTab == 'Workouts') && (
              <div className="c-workout-wrapper" style={{ backgroundColor: '#e7e9ed', marginBottom: 0, marginTop: -110 }}>
                <div className="c-workout-content">
                  <h2>Workouts</h2>
                  {/* <span>Set the workouts visible for the client</span><br /><br /> */}
                  <span>Enable/Disable access to workouts</span><br /><br />
                  {
                    loading ? <Loading /> : (
                      <div className="c-exercise-list">
                        {workoutsList.map((item, idx) => (
                          <div className="c-exercise-list-item">
                            <div className="c-exercise-list-item-data">
                              <div style={{ width: 65, position: "relative", height: 45, float: 'left'  }}>
                                <label className="switch">
                                  {activeWorkouts.filter(workout => workout === item.id).length > 0 ? (
                                    <input type="checkbox" onChange={ () => { unCheckWorkouts(item.id) } } name="Back"  checked />
                                  ):(
                                    <input type="checkbox" onChange={ () => { doCheckWorkouts(item.id) } } name="Back"  />
                                  )}
                                  <span className="slider round"></span>
                                </label>
                              </div>
                              <div className="c-exercise-text">
                                <h3>{item.name}</h3>
                                <span style={{ fontWeight: 300 }}>{item.supersets && (item.supersets.length + " series")}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )
                  }
                </div> 
              </div>
            )
          }
          {
            (visibleTab == 'Mealplans') && (
              <div className="c-workout-wrapper" style={{ backgroundColor: '#e7e9ed', marginBottom: 0, marginTop: -110 }}>
                <div className="c-workout-content">
                  <h2>Mealplan</h2>
                  {/* <span>Set the mealplan visible for the client</span><br /><br /> */}
                  <span>Enable/Disable access to mealplans</span><br /><br />
                  {
                    loading ? <Loading /> : (
                      <div className="c-exercise-list">
                        {mealplansList.map((item, idx) => (
                            item.name && (
                              <div className="c-exercise-list-item">
                                <div className="c-exercise-list-item-data">
                                  <div style={{ width: 65, position: "relative", height: 45, float: 'left'  }}>
                                    <label className="switch">
                                      {activeMealplans.filter(program => program === item.id).length > 0 ? (
                                        <input type="checkbox" onChange={ () => { unCheckMealplans(item.id) } } name="Back"  checked />
                                      ):(
                                        <input type="checkbox" onChange={ () => { doCheckMealplans(item.id) } } name="Back"  />
                                      )}
                                      <span className="slider round"></span>
                                    </label>
                                  </div>
                                  <div className="c-exercise-text">
                                    <h3>{item.name}</h3>
                                    <span style={{ fontWeight: 300 }}>{item.plan && (item.plan.length + " meals")}</span>
                                  </div>
                                </div>
                              </div>
                            )
                          ))}
                        </div>
                    )
                  }
                  

                </div> 
              </div>
            )
          }
        </>
      



    </div>
  );
}
